import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';
import Utils from '../../utils';
import { Context } from '../context';

export default class Pannel extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      open: false,
    };
  }
  
  getStyle = (side) => {
    const style = {
      padding: '0',
      backgroundSize: 'cover',
    };
    if (Utils.getCampaignData(this.props.backgroundImg)) style.backgroundImage = `url('${Context.clientUrl}campaigns/assets/${this.props.campaignId}/${Context.device}${Utils.getCampaignData(this.props.backgroundImg)}')`;
    if (Utils.getCampaignData(this.props.height)) style.maxHeight = Utils.getCampaignData(this.props.height);
    if (Utils.getCampaignData(this.props.textColor)) style.color = Utils.getCampaignData(this.props.textColor);
    const styleKey = ['backgroundColor', 'fontFamily', 'width', 'top', 'left', 'bottom', 'right'];
    styleKey.forEach((key) => {
      if (Utils.getCampaignData(this.props[key])) style[key] = Utils.getCampaignData(this.props[key]);
    });

    if (!this.state.open) {
      style[side] = `-${parseInt(style.width)}px`;
    }

    return style;
  };

  getExitStyle = () => {
    const exitStyle = {
      background: 'none', border: 'none', position: 'absolute',
    };
    if (Utils.getCampaignData(this.props.exitButtonColor)) exitStyle.background = this.props.exitButtonColor.value;
    if (Utils.getCampaignData(this.props.exitButtonFontColor)) exitStyle.color = this.props.exitButtonFontColor.value;

    return exitStyle;
  };

  getOpenStyle = (side, global) => {
    const style = {
      transform: side === 'left' ? 'rotate(-90deg)' : 'rotate(90deg)',
      transformOrigin: '0px 0px',
      position: 'absolute',
      width: `${parseInt(global.maxHeight)}px`,
      height: '25px',
      top: side === 'left' ? `${parseInt(global.maxHeight)}px` : '0',
      bottom: '0',
      right: '0',
      left: side === 'left' ? '3px' : '22px',
      opacity: this.state.open ? 0 : 1,
      transition: 'opacity 200ms',
    };

    return style;
  };

  toggleBlock = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  render() {
    const side = Utils.getCampaignData(this.props.emplacement, 'left')
    const toggleClass = !this.state.open ? 'WioClosed' : '';
    const style = this.getStyle(side);

    return (
      <div>
        <div
          id="wio_ban"
          style={style}
          className={`WioPannel Wio${side}`}
        >
          <div
            id="wioContent"
            dangerouslySetInnerHTML={{ __html: this.state.content }}
          />
          {this.insertDiscoverButton()}
          <button
            className={`WioPannelOpen ${toggleClass}`}
            style={this.getExitStyle()}
            onClick={this.toggleBlock}
          >
            <span
              style={this.getOpenStyle(side, style)}
            >
              {Utils.getCampaignData(this.props.openButtonText, 'Votre promotion')}
            </span>
          </button>
        </div>
      </div>
    )
  };
};
